import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Row,
  Col,
  Button,
  ButtonToolbar,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { reduxForm, formValueSelector, formPropTypes, SubmissionError } from 'redux-form';
import { NumberField } from '../../fields';
import { getGraphQLErrorAsString } from '../../../utils/graphQLErrorHandlers';


export const FORM_NAME = 'guaranteedTimeForm';

const calculateTotalSeconds = (hours, minutes) => {
  const hoursValue = (hours) || 0;
  const minutesValue = (minutes) || 0;
  const currentSeconds = (hoursValue * 3600) + (minutesValue * 60);
  return (currentSeconds);
};

const validate = (values, props) => {
  const { timesheet } = props;
  const { user, payPeriodSummary } = timesheet;
  const { total_seconds: totalSeconds } = payPeriodSummary.undertimeDuration;

  const errors = {};
  const { minutes, hours } = values;

  if (minutes > 59 || minutes < 0) {
    errors.minutes = 'Invalid minutes value';
  }
  if (hours > 80 || hours < 0) {
    errors.hours = 'Invalid hours value';
  }
  if (user.payroll_type === 'hourly_salary' && (calculateTotalSeconds(hours, minutes) !== totalSeconds)) {
    errors.hours = 'You must add the recommended guarenteed hours for salary employees.';
    errors.minutes = 'You must add the recommended guarenteed hours for salary employees.';
  }

  if (calculateTotalSeconds(hours, minutes) > totalSeconds) {
    errors.hours = 'Over Max Guarenteed Time';
    errors.minutes = 'Over Max Guarenteed Time';
  }
  return errors;
};


/* eslint-disable react/forbid-prop-types, react/require-default-props */
const propTypes = {
  initialValues: PropTypes.object.isRequired,
  approve: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  timesheet: PropTypes.object.isRequired,
  supervisorId: PropTypes.number.isRequired,

  handleSubmit: PropTypes.func.isRequired,
  ...formPropTypes,
};
/* eslint-enable */

const buttonYesText = (hoursParam, minutesParam) => {
  let hoursString = '';
  let minutesString = '';

  if (hoursParam || minutesParam) {
    if (hoursParam) {
      hoursString = `${hoursParam} hrs`;
    }
    if (minutesParam) {
      minutesString = `${minutesParam} mins`;
    }
    return (`Yes, Add ${hoursString} ${minutesString}`);
  }
  return (
    'No, Approve As Is'
  );
};

const GuaranteedTimeForm = (props) => {
  const {
    handleSubmit,
    submitting,
    invalid,
    error,
  } = props;

  const {
    hide,
    timesheet,
    supervisorId,
    approve,
  } = props;


  const onSubmit = async (values) => {
    const { hours, minutes } = values;
    const currentSeconds = calculateTotalSeconds(hours, minutes);

    try {
      await approve(timesheet, true, currentSeconds, supervisorId);
    } catch (e) {
      throw new SubmissionError({ _error: getGraphQLErrorAsString(e.graphQLErrors) });
    }
  };

  const {
    hours,
    minutes,
  } = props;

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row style={{ paddingBottom: '20px' }}>
          <Col md={6}>
            <FormGroup>
              <NumberField
                name="hours"
                label="Hours"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <NumberField
                name="minutes"
                label="Minutes"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <ButtonToolbar className="pull-right">
              <Button bsStyle="warning" onClick={hide}>
                Cancel
              </Button>
              <Button
                bsStyle="primary"
                type="submit"
                disabled={submitting || invalid}
              >
                {buttonYesText(hours, minutes)}
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
        {error && <span className="form-error"><strong>{error}</strong></span>}
      </form>
    </React.Fragment>
  );
};


GuaranteedTimeForm.propTypes = propTypes;

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

const selector = formValueSelector(FORM_NAME);

const formValues = connect((state, ownProps) => {
  const hours = selector(state, 'hours');
  const minutes = selector(state, 'minutes');
  return {
    hours,
    minutes,
  };
}, {});

const enhance = compose(
  withForm,
  formValues,
);

export default enhance(GuaranteedTimeForm);
